import { render, staticRenderFns } from "./translation-job-header-controls.vue?vue&type=template&id=105e3a76&scoped=true"
import script from "./translation-job-header-controls.vue?vue&type=script&lang=ts"
export * from "./translation-job-header-controls.vue?vue&type=script&lang=ts"
import style0 from "./translation-job-header-controls.vue?vue&type=style&index=0&id=105e3a76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105e3a76",
  null
  
)

export default component.exports